import { createSlice } from "@reduxjs/toolkit";
import { extendSliceWithAssignees } from "slices/assignees/utils";

export const initialState = {
  data: null,
  isLoading: false,
  showEditPanel: false,
};

export const proposalSlice = createSlice({
  name: "proposal",
  initialState,
  reducers: {
    reset: () => initialState,
    setIsLoading(state, { payload: isLoading = false }) {
      state.isLoading = isLoading;
    },
    setProposal: (state, action) => {
      state.data = action.payload;
    },
    setHasProposalOutline: (state, { payload }) => {
      if (state.data) {
        state.data.hasProposalOutline = Boolean(payload);
      }
    },
    setShowEditPanel: (state, { payload }) => {
      state.showEditPanel = payload;
    },
    ...extendSliceWithAssignees({
      rootPath: "data",
      actionName: "setProposalAssignees",
    }),
  },
});

export const {
  reset,
  setIsLoading,
  setProposal,
  setHasProposalOutline,
  setProposalAssignees,
  setShowEditPanel,
} = proposalSlice.actions;

export default proposalSlice;
